import { CKEditor } from '@ckeditor/ckeditor5-react';
import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { TextareaAutosize } from '@/components/ui/textarea-autosize';
import MotivatorTextPicker from './MotivatorTextPicker';

export default function StepInfo(props) {
  const { step, form, question } = props;
  const [description, setDescription] = useState('');
  const [motivatorText, setMotivatorText] = useState('');

  const handleDescriptionChange = data => {
    const value = data.getData();
    setDescription(value);
    form.setFieldValue('description', value);
  };

  const handleMotivatorTextChange = data => {
    const value = data.getData();
    setMotivatorText(value);
    form.setFieldValue('motivator-texts-attributes.[0].body', value);
  };

  useEffect(() => {
    if (question) {
      setDescription(question.description);
      setMotivatorText(question['motivator-texts'][0]?.body);
    }
  }, [question]);

  return (
    step === 'informacoes' && (
      <div className="page__content mb-12 animate-fade-in">
        <div className="new-questions__header">
          <h2 className="new-questions__title">{form.values.code || t('exams.titleNewQuestion')}</h2>
        </div>

        <div className="new-questions__body">
          <p className="new-questions__subtitle">{t('exams.subtitleMotivatorText')}</p>

          <MotivatorTextPicker
            onSelect={selected => {
              form.setFieldValue('motivator-text-ids', [selected.id]);
              setMotivatorText(selected.body); // preview do texto reusado no editor existente
            }}
          />

          {question && !form?.values?.['motivator-texts-attributes']?.[0]?.body && !form?.values?.['motivator-text-ids']?.length && (
            <button
              type="button"
              className="form__control"
              onClick={() => {
                // Saneamento do legado: o admin seleciona no comando o trecho que na
                // verdade é texto de apoio; ele vira o motivator-text e o restante fica
                // como comando enxuto.
                const full = form.values.description || '';
                const cut = window.getSelection()?.toString();
                if (!cut || !full.includes(cut)) {
                  alert('Selecione no comando o trecho que é texto de apoio.');
                  return;
                }
                const remaining = full.replace(cut, '').trim();
                form.setFieldValue('motivator-texts-attributes.[0].body', cut);
                form.setFieldValue('description', remaining);
                setMotivatorText(cut);
                setDescription(remaining);
              }}
            >
              Extrair texto de apoio do comando
            </button>
          )}

          <div className="form__row">
            <label
              className="form__label"
              htmlFor="motivator-texts-attributes"
            >
              {t('exams.formTitleMotivatorText')}
            </label>
            <CKEditor
              editor={Editor}
              data={motivatorText}
              config={{ placeholder: t('exams.pInsertMotivatingText') }}
              onChange={(event, editor) => {
                handleMotivatorTextChange(editor);
              }}
              onBlur={(event, editor) => {
                handleMotivatorTextChange(editor);
              }}
            />
            {form?.touched?.['motivator-texts-attributes']?.[0]?.body && form?.errors?.['motivator-texts-attributes']?.[0]?.body && <span style={{ color: 'red' }}>{form?.errors?.['motivator-texts-attributes']?.[0]?.body}</span>}
          </div>

          <div className="form__row">
            <label
              className="form__label"
              htmlFor="description"
            >
              *{t('exams.formTitleStatementQuestion')}
            </label>

            <CKEditor
              editor={Editor}
              data={description}
              config={{ placeholder: t('exams.pInsertStatement') }}
              onChange={(event, editor) => {
                handleDescriptionChange(editor);
              }}
              onBlur={(event, editor) => {
                handleDescriptionChange(editor);
              }}
            />
            {form?.touched?.description && form?.errors?.description && <span style={{ color: 'red' }}>{form?.errors.description}</span>}
          </div>

          <div className="form__row">
            <label
              className="form__label"
              htmlFor="print"
            >
              {t('exams.titlePress')}
            </label>

            <input
              className="form__control"
              placeholder={t('exams.placeholderPress')}
              id="print"
              name="print"
              type="text"
              value={form?.values?.['motivator-texts-attributes']?.[0]?.print}
              onChange={e => form.setFieldValue('motivator-texts-attributes.[0].print', e.target.value)}
            />
            {form?.touched?.['motivator-texts-attributes']?.[0]?.print && form?.errors?.['motivator-texts-attributes']?.[0]?.print && <span style={{ color: 'red' }}>{form?.errors?.['motivator-texts-attributes']?.[0]?.print}</span>}
          </div>
        </div>
      </div>
    )
  );
}
